import React from 'react'
import './creations.css'

const Creations = () => {
  return (
    <section id='creations'>
        <h5>My Activities</h5>
        <h2>Creations & Awards</h2>
        <div className='container creations_container'>
            <article className='creations'>
                <div className='creations_head'>
                    <h3>A Fairy Tale in Thailand</h3>
                    
                </div>
                <div className='button button-creations'> <a href='https://drive.google.com/file/d/1PsRvfyS-wGajSC2Ih2s3VNiVO2VGQcyf/view?usp=drivesdk' target='_blanl'>Watch</a></div>
                
            </article>
            <article className='creations'>
                <div className='creations_head'>
                    <h3>The Smart Career (Documentary)</h3>
                </div>
                <div className='button button-creations'> <a href='https://drive.google.com/file/d/1psAfJ9hfPFx7CpeuMux5_ubXFiMju83d/view?usp=drivesdk' target='_blanl'>Watch</a></div>
                
            </article>
            <article className='creations'>
                <div className='creations_head'>
                    <h3>Tears of Joy</h3>
                </div>
                <div className='button button-creations'><a href='https://drive.google.com/file/d/1PbNOFxB81htef7-nX3wRBUbwMJu3I1lL/view?usp=drivesdk' target='_blanl'>Watch</a> </div>
                
            </article>

        </div>
    </section>
  )
}

export default Creations